"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.splitChosingMiddle = exports.getCellStyle = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _constants = require("./constants");
/**
 * Выбирает нужный цвет, в зависимости от priceCoefficient
 * @param {number} priceCoefficient процент от минимальной цены за ночь
 * @returns {object} Объект с цветом категории
 */
var getCellStyle = exports.getCellStyle = function getCellStyle(priceCoefficient) {
  var cell = _constants.CATEGORY.find(function (_ref) {
    var min = _ref.min,
      max = _ref.max;
    return min <= priceCoefficient && priceCoefficient <= max;
  });
  return cell || _constants.CATEGORY_DEFAULT;
};
var splitChosingMiddle = exports.splitChosingMiddle = function splitChosingMiddle(arr, columnCount, targetStartDate) {
  var index = arr.findIndex(function (_ref2) {
    var _ref3 = (0, _slicedToArray2["default"])(_ref2, 1),
      date = _ref3[0];
    return date === targetStartDate;
  });
  if (columnCount === 5) {
    return [].concat((0, _toConsumableArray2["default"])(arr.slice(index - 2, index)), (0, _toConsumableArray2["default"])(arr.slice(index, index + 3)));
  }
  if (columnCount === 10) {
    return [].concat((0, _toConsumableArray2["default"])(arr.slice(index - 4, index)), (0, _toConsumableArray2["default"])(arr.slice(index, index + 6)));
  }
  return arr;
};